// The emoji a user picked last, newest first, kept in the browser. The
// quick picker shows the first six.

const KEY = 'pleroma-fe-recent-emoji'
const HISTORY = 20
const STRIP = 6

const unicode = (replacement, displayText) => ({
  displayText,
  replacement,
  imageUrl: null,
})

export const DEFAULT_RECENT = [
  unicode('👍', 'thumbs up'),
  unicode('❤️', 'red heart'),
  unicode('😂', 'face with tears of joy'),
  unicode('😮', 'face with open mouth'),
  unicode('😢', 'crying face'),
  unicode('🎉', 'party popper'),
]

// a custom emoji and a unicode one can share a name
const keyOf = (emoji) =>
  emoji.imageUrl ? `:${emoji.displayText}:` : emoji.replacement

const pick = ({ displayText, replacement, imageUrl }) => ({
  displayText,
  replacement,
  imageUrl: imageUrl ?? null,
})

export const addRecent = (list, emoji) =>
  [pick(emoji), ...list.filter((e) => keyOf(e) !== keyOf(emoji))].slice(
    0,
    HISTORY,
  )

// custom: false skips custom emoji, e.g. where the server cannot react
// with them
export const recentForStrip = (list, { custom = true } = {}) => {
  const usable = custom ? list : list.filter((e) => !e.imageUrl)
  const used = new Set(usable.map(keyOf))
  return [
    ...usable,
    ...DEFAULT_RECENT.filter((e) => !used.has(keyOf(e))),
  ].slice(0, STRIP)
}

export const loadRecent = (storage = window.localStorage) => {
  try {
    const list = JSON.parse(storage.getItem(KEY))
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

export const saveRecent = (list, storage = window.localStorage) => {
  try {
    storage.setItem(KEY, JSON.stringify(list))
  } catch {
    // private mode or a full quota: the strip falls back to defaults
  }
}
